import { render } from "./mapping-icon.svg?vue&type=template&id=5792e902"
import script from "./mapping-icon.svg?vue&type=script&lang=js"
export * from "./mapping-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1397/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__